window.VCA = window.VCA || {};

window.VCA.ucfahDatalayer = (function ($) {

    if ($('.find-a-hospital').length <= 0) {
        return;
    }

    function datalayerPushClick(action, hospitalAU) {
        //push to datalayer UC
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event':'clickevent',
            'category':'vca urgent care',
            'action': action,
            'label': hospitalAU
        });
    }

    return {
        datalayerPushClick: datalayerPushClick
    };



})(jQuery);

